<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>

    <ykc-table
      ref="YkcTable"
      title="电站充电白名单列表"
      :selectable="false"
      :selectOnIndeterminate="false"
      :data="tableData"
      :columns="tableColumns"
      :operateButtons="tableOperateButtons.filter(item => item.enabled())">
      <ykc-pagination
        slot="pagination"
        ref="YkcPagination"
        direct="flex-end"
        :total="pageInfo.total"
        :page-size.sync="pageInfo.pageSize"
        :current-page.sync="pageInfo.pageIndex"
        @size-change="handlePaginationSizeChange"
        @current-change="handlePaginationCurrentChange"></ykc-pagination>
    </ykc-table>

    <ykc-drawer
      :show.sync="showDrawer"
      :on-close="onDrawerClose"
      :before-cancel="onDrawerCancel"
      :title="drawerType === 'add' ? '添加白名单用户' : '剔除白名单用户'">
      <div class="drawer-main-body" v-if="showDrawer">
        <AddDrawer v-if="drawerType === 'add'" ref="drawerForm" :row="currentRow"></AddDrawer>
        <RemoveDrawer
          v-if="drawerType === 'remove'"
          ref="drawerForm"
          :row="currentRow"></RemoveDrawer>
      </div>
      <template #footer>
        <div class="drawer-button-wrap">
          <ykc-button type="plain" @click="handleDrawerCancel">取消</ykc-button>
          <ykc-button @click="handleDrawerSave">保存</ykc-button>
        </div>
      </template>
    </ykc-drawer>
  </scroll-layout>
</template>

<script>
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { operationsStationChargeWhitelist } from '@/service/apis';
  import { code } from '@/utils';
  import AddDrawer from './AddDrawer.vue';
  import RemoveDrawer from './RemoveDrawer.vue';

  export default {
    name: 'StationChargeWhitelistList',
    components: {
      AddDrawer,
      RemoveDrawer,
    },
    data() {
      return {
        showDrawer: false,
        drawerType: 'add',
        currentRow: {},
        tableData: [],
        pageInfo: {
          pageIndex: 1,
          pageSize: 10,
          total: 0,
        },
        searchParams: {
          stationName: '',
          stationCode: '',
          status: '',
        },
        statusOptions: [
          { id: 0, name: '未开启' },
          { id: 1, name: '已开启' },
        ],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcInput',
            key: 'stationCode',
            label: '电站编码',
            placeholder: '请输入电站编码',
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '白名单配置状态',
            placeholder: '请选择状态',
            data: this.statusOptions,
          },
        ];
      },
      tableColumns() {
        return [
          { label: '电站名称', prop: 'stationName', minWidth: '180px' },
          { label: '电站编码', prop: 'stationCode', minWidth: '160px' },
          {
            label: '白名单配置状态',
            prop: 'status',
            minWidth: '140px',
            scopedSlots: {
              default: ({ row }) => <span>{row.status === 1 ? '已开启' : '未开启'}</span>,
            },
          },
          { label: '白名单用户数', prop: 'userCount', minWidth: '130px' },
          { label: '最后编辑人', prop: 'modifiedByName', minWidth: '120px' },
          {
            label: '最后编辑时间',
            prop: 'modifiedTime',
            minWidth: '170px',
            scopedSlots: {
              default: ({ row }) => <span>{this.formatTime(row.modifiedTime)}</span>,
            },
          },
        ];
      },
      tableOperateButtons() {
        return [
          {
            enabled: () => code('operation:config:whitelist:add'),
            render: (h, button, { row }) => (
              <ykc-button type="text" onClick={() => this.openDrawer('add', row)}>
                添加
              </ykc-button>
            ),
          },
          {
            enabled: () => code('operation:config:whitelist:remove'),
            render: (h, button, { row }) => (
              <ykc-button type="text" onClick={() => this.openDrawer('remove', row)}>
                剔除
              </ykc-button>
            ),
          },
          {
            enabled: () => code('operation:config:whitelist:detail'),
            render: (h, button, { row }) => (
              <ykc-button type="text" onClick={() => this.gotoDetail(row)}>
                详情
              </ykc-button>
            ),
          },
        ];
      },
    },
    created() {
      this.searchTableList();
    },
    methods: {
      searchTableList() {
        const params = {
          ...this.searchParams,
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        if (params.status === '') {
          delete params.status;
        }
        operationsStationChargeWhitelist.list(params).then(res => {
          this.tableData = res?.records || [];
          this.pageInfo.total = res?.total || 0;
        });
      },
      openDrawer(type, row) {
        this.drawerType = type;
        this.currentRow = { ...row };
        this.showDrawer = true;
      },
      gotoDetail(row) {
        this.$router.push({
          path: '/operationCenter/operationConfig/stationChargeWhitelist/details',
          query: {
            stationId: row.stationId,
          },
        });
      },
      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      handleDrawerCancel() {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => done(),
          onConfirm: done => {
            done();
            this.showDrawer = false;
          },
        });
      },
      handleDrawerSave() {
        this.$refs.drawerForm.submitForm().then(() => {
          this.showDrawer = false;
          this.searchTableList();
        });
      },
      onDrawerClose(done) {
        done();
      },
      onDrawerCancel(done) {
        done();
      },
      formatTime(time) {
        if (!time) {
          return '——';
        }
        return String(time).replace('T', ' ').slice(0, 19);
      },
    },
  };
</script>
